/** The money a saved quote stores in `calc_snapshot`, resolved once.
 *
 *  The save writes `grandTotal` from here, and the backend sizes the PDF's
 *  production team off that figure (`_quote_proposal_total`). The live
 *  timeline card sends the same `grandTotal`, so the two always staff the
 *  job alike. Reading `activeC.grandTotal` instead priced an à la carte
 *  quote as the full VEXOS package (Nobu PR: $50,196 against $12,696
 *  saved), put a second artist on it, and showed 3 weeks against the
 *  PDF's 6–7.
 *
 *  À La Carte is visualization-only: no platform setup or monthly. The
 *  monthly is the AGREED one (rep override, then the $1,500 CRM opt-out
 *  floored at $1,000), not the rate card's. */
export function snapshotMoney(activeC, { isAlacarte, monthlyRateOverride, crmIncluded, term }) {
  const autoMonthlyRate = Number(activeC.monthlyRate) || 0;
  const overriddenMonthly = monthlyRateOverride !== null && Number.isFinite(monthlyRateOverride)
    ? Math.max(0, Math.round(monthlyRateOverride))
    : null;
  const baseMonthlyRate = overriddenMonthly !== null ? overriddenMonthly : autoMonthlyRate;
  const effectiveMonthlyRate = crmIncluded ? baseMonthlyRate : Math.max(baseMonthlyRate - 1500, 1000);
  // Revisions ride the viz split; travel bills at signing.
  const acVizSplit = (Number(activeC.vizNet) || 0) + (Number(activeC.revisionsCost) || 0)
    - (Number(activeC.proposalDiscount) || 0) + (Number(activeC.conceptualDesignFee) || 0)
    + (Number(activeC.modelingFee) || 0);
  const acTravel = Number(activeC.travelCost) || 0;
  const acOneTime = acVizSplit + acTravel;
  const oneTime = isAlacarte ? acOneTime : activeC.oneTimeAllIn;
  const recurring = isAlacarte ? 0 : effectiveMonthlyRate * term;
  return {
    autoMonthlyRate, overriddenMonthly, effectiveMonthlyRate,
    acVizSplit, acTravel, acOneTime, oneTime, recurring,
    grandTotal: isAlacarte ? acOneTime : oneTime + recurring,
  };
}
